var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.012,
    height: 9.012,
    viewBox: "0 0 9.012 9.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock_black_24dp",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12019",
    "data-name": "Group 12019"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63881",
    "data-name": "Path 63881",
    d: "M0,0H9.012V9.012H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63882",
    "data-name": "Path 63882",
    d: "M0,0H9.012V9.012H0Z",
    fill: "none",
    opacity: 0.87
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_63883",
    "data-name": "Path 63883",
    d: "M9.257,3.628H8.881V2.877a1.877,1.877,0,1,0-3.755,0v.751H4.751A.753.753,0,0,0,4,4.379V8.134a.753.753,0,0,0,.751.751H9.257a.753.753,0,0,0,.751-.751V4.379A.753.753,0,0,0,9.257,3.628ZM5.877,2.877a1.126,1.126,0,0,1,2.253,0v.751H5.877ZM9.257,8.134H4.751V4.379H9.257ZM7,7.008a.751.751,0,1,0-.751-.751A.753.753,0,0,0,7,7.008Z",
    transform: "translate(-2.498 -0.625)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockBlack);
export default __webpack_public_path__ + "static/media/lock_black.73d4f73daa449648b32d9668ce7bdee3.svg";
export { ForwardRef as ReactComponent };